<template>
  <div class="changepwd">
    <toptitle :title1="titlework" />
    <van-form style="margin-top: 10px">
      <div class="info-pic">
        <!-- <img src="../../assets/resetpassword.png"
             alt=""> -->
      </div>
      <van-field v-model="newpassword"
                 type="password"
                 name="新密码"
                 label="新密码"
                 autocomplete="off"
                 placeholder="请填写新密码"
                 :rules="[{ required: true, message: '请填写新密码' }]" />
      <van-field v-model="newpassword2"
                 type="password"
                 name="输入密码"
                 label="输入密码"
                 autocomplete="off"
                 placeholder="请再次填写密码"
                 :rules="[{ required: true, message: '请再次填写密码' }]" />
      <div class="button-bt">
        <div @click="submit">提交</div>
        <div @click="cleanpassword">返回</div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import toptitle from '../toptitle'
import { ChangePwdDataApi } from '../../request/api'
export default {
  data() {
    name: 'changepwd'
    return {
      titlework: '更改密码',

      newpassword: '',
      newpassword2: '',
    }
  },

  methods: {
    cleanpassword() {
      this.newpassword = ''
      this.newpassword2 = ''
    },
    submit() {
      if (this.newpassword == this.newpassword2) {
        if (!this.newpassword) {
          Toast.fail('请填写密码')
          return
        }

        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          NEWPASSWORD: this.newpassword,
        }
        ChangePwdDataApi(params).then((res) => {
          if (res.CODE === 200) {
            Toast.success(res.MESSAGE)
            this.$router.push('/login')
          } else {
            this.newpassword = ''
            this.newpassword2 = ''
            Toast.fail('密码信息错误')
          }
        })
      } else {
        Toast.fail('两次密码不一致')
      }
    },
  },
  components: {
    toptitle,
  },
  created() {},
}
</script>

<style lang="less" scoped >
.info-pic {
  width: 100px;
  margin: 0 auto;
  padding: 10px;
  text-align: center;
}
/deep/ .van-field__label {
  color: black;
  font-weight: bold;
  font-size: 16px;
}
.button {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
  button {
    width: 50%;
    border: 0;
    color: white;
    background: #007fc6;
  }
}
/deep/.van-button {
  font-size: 16px;
}
.button-bt {
  position: fixed;
  bottom: 0;
  display: flex;
  line-height: 44px;
  text-align: center;
  color: white;
  width: 100%;
  div {
    background: #007fc6;
    width: 50%;
    font-size: 17px;
  }
}
</style>